// extracted by mini-css-extract-plugin
module.exports = {"icon":"search_zero_results_help-module__icon--3UTCQ","link":"search_zero_results_help-module__link--39oYf"};